"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[367],{

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Cookies; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(7516);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Cookies/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  background: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  transform: translateY(100%);\n\n  transition: all 0.3s;\n\n  @media (max-width: 800px) {\n    padding: 0 ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n  max-width: ",
        ";\n  padding: ",
        ";\n\n  display: flex;\n  flex-direction: row;\n\n  svg {\n    min-width: ",
        ";\n    min-height: ",
        ";\n\n    margin-right: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n\n    margin-right: auto;\n\n    a {\n      text-decoration: underline;\n\n      transition: 0.3s;\n\n      &:hover {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  button {\n    margin-left: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-63ed2cf6-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.medium);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-63ed2cf6-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.maxWidth;
}, (p)=>"".concat(p.theme.spacing.medium, " ").concat(p.theme.spacing.xLarge), (param)=>{
    let { theme  } = param;
    return theme.font.large;
}, (param)=>{
    let { theme  } = param;
    return theme.font.large;
}, (p)=>p.theme.spacing.small, (param)=>{
    let { theme  } = param;
    return theme.font.small;
}, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.medium);

;// CONCATENATED MODULE: ./src/themes/default/components/Cookies/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 





const Cookies = (param)=>{
    let { cookies  } = param;
    const defaultCookiesText = "Este site usa cookies para garantir que voc\xea obtenha a melhor experi\xeancia.";
    const acceptCookies = (0,react.useCallback)(()=>{
        const cookiesElement = document.getElementById("cookies-container");
        localStorage.setItem("@PraVendas:cookiesAccepted", "true");
        if (cookiesElement) cookiesElement.style.transform = "translateY(100%)";
    }, []);
    (0,react.useEffect)(()=>{
        const cookiesElement = document.getElementById("cookies-container");
        const storagedCookiesAccepted = localStorage.getItem("@PraVendas:cookiesAccepted");
        if (cookiesElement) {
            if (storagedCookiesAccepted && storagedCookiesAccepted === "true") {
                cookiesElement.style.transform = "translateY(100%)";
            } else {
                cookiesElement.style.transform = "translateY(0)";
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        id: "cookies-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiCookie */.cbB, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        (cookies === null || cookies === void 0 ? void 0 : cookies.text) || defaultCookiesText,
                        (cookies === null || cookies === void 0 ? void 0 : cookies.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: cookies.link,
                            target: "_blank",
                            children: "Saber mais"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    font: "small",
                    onClick: acceptCookies,
                    children: "Entendi"
                })
            ]
        })
    });
};
/* harmony default export */ var components_Cookies = (Cookies);


/***/ })

}]);